import { captureException } from '@sentry/minimal';
import { ConfigErrors, ErrorKey } from '../types/';

/**
 * Report ConfigErrors to Sentry
 * @param errors an object containing config errors
 */
const reportErrors = (errors: ConfigErrors): void => {
  for (const k in errors) {
    const key = k as ErrorKey;

    if (errors[key].sendToSentry) {
      const error = errors[key];
      const remediationStatus = error.remediated !== undefined ? `, remediation status: ${error.remediated}` : '';

      const errObj = new Error(`${error.message}${remediationStatus}`);
      errObj.name = error.name;

      captureException(errObj);
    }
  }
};

export default reportErrors;
